import moment from "moment";
import config from "config/config";
import { getToken } from "js/formatting/getToken";
import { isDeferredAnnuityPlanCode } from "js/utilities";

export async function getFinancials(policy) {
  if (policy?.contractID) {
    let options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key": config.ODS_API_KEY,
        Authorization: `bearer ${getToken()}`,
      },
      body: JSON.stringify({
        gXdpApi: {
          transactionType: {
            sourceNameSpace: "LIFESYS",
            eventName: "GETFINANCIALS",
            targetNameSpace: "GIDP",
            operation: "GET",
          },
          gIdpPayLoad: {
            cashValue: {
              policyId: policy?.contractID,
              asOfDate: isDeferredAnnuityPlanCode(policy)
                ? moment().add(-1, "days").format("MM/DD/YYYY")
                : moment().format("MM/DD/YYYY"),
            },
            addOnProperties: {
              lifesys: {
                policyHolder: {
                  company: config.COMPANY,
                  clientName: config.CLIENTNAME,
                  system: "LSN",
                  lifeSysDataset: "F",
                  includePolicyFields:
                    policy?.status?.toLowerCase() === "extended term"
                      ? "N"
                      : "Y",
                  includeadditionalday2Fields: "Y",
                  includebenefitSummary: "Y",
                  includeGuaranteeCurrentIntRate: "Y",
                },
              },
            },
          },
          correlationID: moment().format("YYYY-MM-DD HH:MM:SS"),
          addOnProperties: {},
        },
      }),
    };
    const response = await fetch(
      config.ODS_API_BASE_URL + "/ce-runtime/GetFinancials",
      options
    );
    if (!response.ok) {
      throw response;
    } else {
      const data = await response.json();
      if (data?.gXdpApi?.success) {
        return data.gXdpApi?.gIdpPayLoad?.cashValue;
      }
      return;
    }
  }
}
